import { requests } from '@/libs/axios/axios'
import { OrganizationsEndpoints } from '../organizations-endpoints'

async function getOrganizationUsers(id: number) {
  return requests.get(`${OrganizationsEndpoints.ORGANIZATIONS}/${id}/users`)
}

export default getOrganizationUsers
